import { SearchQueryOrderDirection } from "types/generated";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";

enum FilterItemKeys {
  Name = "name",
  Space = "space",
  CreatedAt = "createdAt",
  Favorite = "starred",
}

export const FILTERS_ORDER_SETTINGS_KEY = "modulesNewFiltersOrder";
export const INITIAL_SORT_OPTION = FilterItemKeys.Favorite;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;

export const FILTER_TYPE = "modules";
export const MODULES_LIMIT = 50;
export const MODULES_LIMIT_STORAGE_KEY = "modulesNewLimit";

export const ANALYTICS = {
  analyticsPage: AnalyticsPageModule.ModulesList,
};

export const SHARED_MODULE_ACCESS_INFO =
  "This module is shared from space you don’t have access to. You don’t have permissions to see its details or edit it.";
